"use client"

import { useState } from "react"
import "./HealthFaq.css"

const faqData = [
  {
    question: "What is Healthtech?",
    answer:
      "Healthtech, short for health technology, refers to the use of technology to enhance healthcare services, improve patient outcomes, and streamline medical processes.",
  },
  {
    question: "What is digital acceleration in healthcare?",
    answer:
      "Digital acceleration in healthcare refers to the rapid adoption and integration of advanced technologies to enhance patient care, streamline processes, and stay competitive in the evolving healthcare landscape.",
  },
  {
    question: "What are healthtech solutions?",
    answer:
      "Healthtech solutions refer to the use of technology to improve healthcare services. This includes software, hardware, and services designed to enhance patient care, streamline clinical processes, and improve health outcomes.",
  },
  {
    question:
      "What are healthcare digital solutions?",
    answer:
      "Healthcare digital solutions encompass mobile health apps, cloud-based systems, wearable devices, and telehealth platforms. These solutions enable remote monitoring, better data management, and enhanced patient engagement.",
  },
  {
    question: "How can digital healthcare solutions benefit my institution?",
    answer:
      "Digital solutions in healthcare improve efficiency, accuracy, and patient care. From electronic health records to telemedicine, these solutions enhance overall healthcare delivery.",
  },
  {
    question: "How do you ensure security of patient data in your solution?",
    answer:
      "We prioritize patient data security and compliance with industry regulations. Our solutions are built with robust security measures to safeguard sensitive healthcare information.",
  },
  {
    question:
      "How is technology transforming healthcare?",
    answer:
      "Technology in healthcare is revolutionising the industry by introducing advanced data analytics, telemedicine, electronic health records (EHRs), and AI-driven diagnostics. These innovations lead to more personalised care, improved patient outcomes, and more efficient healthcare delivery.",
  },
]

const FAQSection = () => {
  const [openItems, setOpenItems] = useState([])

  const toggleItem = (index) => {
    setOpenItems((prev) => (prev.includes(index) ? prev.filter((i) => i !== index) : [...prev, index]))
  }

  return (
    <div className="faq-container" id="faq">
      <div className="container">
      <div className="faq-wrapper">
        {/* Header */}
        <div className="header-section7901">
          <h1 className="main-title">EVERYTHING YOU NEED TO KNOW ABOUT</h1>
          <h2 className="sub-title">HEALTHCARE TECHNOLOGY SOLUTIONS</h2>
        </div>

        <div className="content-grid">
          {/* Left Sidebar */}
          <div className="sidebar">
            <div className="sidebar-image">
              <img src="/faq.webp?height=10&width=10" alt="FAQ Illustration" />
            </div>

            <div className="sidebar-content">
              <p className="sidebar-text">
                Browse the Frequently Asked Questions and get your answers. Or better yet - get in touch with our team
                and let's talk!
              </p>
              <button className="quote-button">GET A QUOTE</button>
            </div>
          </div>

          {/* FAQ Section */}
          <div className="faq-section">
            <div className="faq-list">
              {faqData.map((faq, index) => (
                <div key={index} className="faq-item">
                  <div className="faq-question" onClick={() => toggleItem(index)}>
                    <p className="question-text">{faq.question}</p>
                    <div className="chevron-icon">
                      {openItems.includes(index) ? (
                        <svg
                          width="20"
                          height="20"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                        >
                          <polyline points="18,15 12,9 6,15"></polyline>
                        </svg>
                      ) : (
                        <svg
                          width="20"
                          height="20"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                        >
                          <polyline points="6,9 12,15 18,9"></polyline>
                        </svg>
                      )}
                    </div>
                  </div>
                  {openItems.includes(index) && (
                    <div className="faq-answer">
                      <p className="answer-text">{faq.answer}</p>
                    </div>
                  )}
                </div>
              ))}
            </div>

            {/* Scroll Indicator */}
            <div className="scroll-indicator">
              <div className="scroll-dot"></div>
              <div className="scroll-bar"></div>
              <div className="scroll-dot"></div>
            </div>
          </div>
        </div>

        {/* Bottom CTA Section */}
        <div className="cta-section">
          <div className="cta-content">
            <div className="cta-text">
              <h3 className="cta-title">STILL HAVE QUESTIONS?</h3>
              <p className="cta-description">
                Our team of business developers and project managers can help you to clarify any questions you have
                related. Feel free to chat with us anytime.
              </p>
            </div>
            <button className="call-button">BOOK A CALL</button>
          </div>
        </div>
      </div>
      </div>
    </div>
  )
}

export default FAQSection
